export default {
  "meta.title": "Guía del Spreadsheet de USFans: encuentra productos y compra mejor",
  "meta.description":
    "Aprende a usar el Spreadsheet de USFans: explora productos por categoría, compara, comprende el QC, el envío y los consejos de compra, y compra con confianza.",

  "breadcrumb.home": "Inicio",
  "breadcrumb.current": "Guía del Spreadsheet",

  "title": "Guía del Spreadsheet de USFans: encuentra productos, compara y compra de forma más inteligente",
  "lead":
    "El Spreadsheet de USFans es una de las formas más útiles de descubrir y comparar productos en muchas categorías. Esta guía original explica cómo funciona, cómo navegar por las categorías y qué verificar antes de comprar, para que tomes mejores decisiones.",

  "toc.title": "Tabla de contenidos",

  "s1.title": "¿Qué es el Spreadsheet de USFans?",
  "s1.p1":
    "El Spreadsheet de USFans es un catálogo de productos compartido y organizado. En lugar de una página con enlaces aleatorios, agrupa los artículos en categorías claras como Zapatos, Sudaderas, Camisetas, Chaquetas, Pantalones, Gorros, Bolsos y Accesorios. Esta estructura facilita encontrar un tipo concreto de producto y comparar lo disponible.",
  "s1.p2":
    "Mucha gente usa el spreadsheet como punto de partida para investigar productos. Te permite ver de un vistazo qué categorías existen, qué productos hay y a dónde ir después para saber más.",

  "s2.title": "Cómo usar el Spreadsheet paso a paso",
  "s2.p1":
    "Usar el spreadsheet es sencillo, incluso si eres nuevo. Sigue estos pasos para aprovecharlo al máximo.",
  "s2.li1": "Elige una categoría que te interese, como Zapatos o Bolsos.",
  "s2.li2": "Revisa los productos listados en esa categoría.",
  "s2.li3": "Compara la información disponible, incluidas fotos y descripciones.",
  "s2.li4": "Verifica las notas de QC y los detalles de envío antes de decidir.",
  "s2.li5": "Sigue el enlace al sitio principal para ver los detalles y pedir.",
  "s2.p2":
    "Como el spreadsheet está organizado por categorías, ahorras tiempo frente a una lista desordenada. Puedes ir directo a la sección que te importa.",

  "s3.title": "Explora las principales categorías de productos",
  "s3.p1":
    "El spreadsheet cubre una amplia variedad de productos. Estas son las principales categorías que encontrarás, con una breve nota sobre cada una.",
  "s3.shoes": "Zapatos — zapatillas, calzado casual y deportivo.",
  "s3.hoodies": "Sudaderas/Sweaters — jerséis y cremalleras.",
  "s3.tshirts": "Camisetas — de manga corta y larga.",
  "s3.jackets": "Chaquetas — ropa de abrigo para cada temporada.",
  "s3.pants": "Pantalones/Shorts — vaqueros, chinos y shorts.",
  "s3.headwear": "Gorros — gorras, sombreros y beanies.",
  "s3.sets": "Conjuntos — atuendos coordinados a juego.",
  "s3.underwear": "Ropa interior/Calzoncillos — ropa interior y bóxers.",
  "s3.jersey": "Camisetas deportivas — de equipos y deporte.",
  "s3.accessories": "Accesorios — pequeños complementos y extras.",
  "s3.bags": "Bolsos — mochilas, bolsos de mano y tote bags.",
  "s3.belts": "Cinturones — de cuero y casuales.",
  "s3.perfumes": "Perfumes — fragancias para hombre y mujer.",
  "s3.other": "Otros artículos — varios y novedades.",
  "s3.p2":
    "Puedes explorar cada categoría desde la página de inicio usando el menú desplegable o las tarjetas. Cada una abre la sección correspondiente en el sitio principal.",

  "s4.title": "Qué verificar antes de comprar",
  "s4.p1":
    "Una buena decisión de compra empieza por revisar rápidamente la información del producto. Estos son los puntos clave a comprobar en cada anuncio.",
  "s4.li1": "Fotos del producto — asegúrate de que muestran claramente el artículo.",
  "s4.li2": "Descripción — lee los detalles de material, talla y color.",
  "s4.li3": "Información de QC — busca fotos de control de calidad si están disponibles.",
  "s4.li4": "Condiciones de envío — entiende el coste y el tiempo estimado.",
  "s4.li5": "Métodos de pago — confirma las opciones disponibles.",
  "s4.p2":
    "Tomarte unos segundos para verificar estos detalles te evita sorpresas y te ayuda a elegir productos que coincidan con lo que esperas.",

  "s5.title": "Notas sobre envío y entrega",
  "s5.p1":
    "Los costes y tiempos de envío pueden variar según tu ubicación y el producto. En general, los artículos más pesados o voluminosos pueden costar más, y los pedidos internacionales tardan más que los nacionales.",
  "s5.p2":
    "Revisa siempre la información de envío que se muestra en el sitio principal antes de hacer un pedido. Si un anuncio incluye una estimación, úsala como guía y no como garantía.",

  "table.caption": "Comparación rápida: qué verificar en cada producto",
  "table.head1": "Factor",
  "table.head2": "Qué verificar",
  "table.head3": "Por qué importa",
  "table.r1c1": "Producto",
  "table.r1c2": "Fotos y descripción",
  "table.r1c3": "Ayuda a investigar",
  "table.r2c1": "QC",
  "table.r2c2": "Info de control de calidad",
  "table.r2c3": "Muestra la calidad",
  "table.r3c1": "Envío",
  "table.r3c2": "Métodos de envío actuales",
  "table.r3c3": "Ayuda a planificar",
  "table.r4c1": "Pago",
  "table.r4c2": "Condiciones de pago",
  "table.r4c3": "Mantiene tu pedido seguro",

  "faq.title": "Preguntas frecuentes",
  "faq.q1": "¿El Spreadsheet de USFans es gratis para explorar?",
  "faq.a1":
    "Sí, explorar las categorías y la información de productos a través de este recurso es gratis. Solo pagas si decides comprar algo en el sitio principal.",
  "faq.q2": "¿Puedo comprar directamente en este sitio?",
  "faq.a2":
    "No. Este sitio es un recurso informativo que te redirige al sitio principal de USFans, donde se completan las compras.",
  "faq.q3": "¿Con qué frecuencia se actualiza el spreadsheet?",
  "faq.a3":
    "El spreadsheet se mantiene y actualiza regularmente. Para los anuncios más recientes, consulta siempre el sitio principal.",
  "faq.q4": "¿Cómo encuentro una categoría específica?",
  "faq.a4":
    "Usa el menú desplegable o las tarjetas de categorías en la página de inicio para ir directo a la sección que necesitas.",

  "cta.title": "Empieza a explorar el Spreadsheet de USFans",
  "cta.text":
    "Ahora que entiendes cómo funciona, explora las categorías y compara antes de comprar.",
  "cta.back": "Volver al inicio",

  "safety.title": "Nota de seguridad",
  "safety.text":
    "Esta guía solo proporciona información. Verifica siempre los detalles del producto y las condiciones de envío en el sitio principal antes de completar cualquier compra.",
};